import { CardioSelectedIcon } from "@images/svgIcons/cardioIcon"
import { GymSelectedIcon } from "@images/svgIcons/gymIcon"
import { WeightliftingSelectedIcon } from "@images/svgIcons/weightliftingIcon"
import { Modality } from "@modules/profile/publicProfile/types/publicProfileTypes"

export const getModalityTagImage = (modality: Modality, size: number) => {
  return {
    [Modality.GYM]: <GymSelectedIcon color="" width={size} height={size} />,
    [Modality.WEIGHT_LIFTING]: <WeightliftingSelectedIcon color="" width={size} height={size} />,
    [Modality.METCON]: <CardioSelectedIcon color="" width={size} height={size} />,
  }[modality]
}
